import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.js';
import { BrowserRouter } from 'react-router-dom';
import { FormProvider } from './context/FormContext.jsx';
import './index.css';
import 'react-tooltip/dist/react-tooltip.css'

import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { BackgroundProvider } from './components/new/BackgroundProvider.jsx';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDuWbN53Bj0WNzrX8n-sx8AiubfMUtRtnA",
  authDomain: "invoice-instagram.firebaseapp.com",
  projectId: "invoice-instagram",
  storageBucket: "invoice-instagram.firebasestorage.app",
  messagingSenderId: "178090363819",
  appId: "1:178090363819:web:91c52cf7ef35dcb9cce0ee",
  measurementId: "G-RET1ZY8YN4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BackgroundProvider>
      <BrowserRouter>
        <FormProvider>
          <App />
        </FormProvider>
      </BrowserRouter>
    </BackgroundProvider>
  </React.StrictMode>
);
